import React from "react";

const NavBar = () => {
  return (
    <nav className="navbar navbar-dark bg-dark fix">
      <div className="container-fluid">
        <a className="navbar-brand" href="#">
          H4G x IDMC
        </a>
      </div>
    </nav>
  );
};

export default NavBar;
